import { createComponent } from 'react-commons';

import style from '../index.module.scss';

export default createComponent('HeaderLinkCaret', { style }, function HeaderLinkCaret ({ className }) {
  return (
    <svg className={className} width='13' height='11' viewBox='0 0 16 15' fill='none'>
      <path d='M10.5981 12.8205C9.44338 14.8205 6.55662 14.8205 5.40192 12.8205L0.598076 4.5C-0.556625 2.5 0.886751 0 3.19615 0H12.8038C15.1132 0 16.5566 2.5 15.4019 4.5L10.5981 12.8205Z' />
    </svg>
  );
});
